import {
  SET_HEATMAP_METRIC,
  SET_HEATMAP_DATE_RANGE,
  SET_HEATMAP_HIGH_COLOR,
  SET_HEATMAP_LOW_COLOR,
  SET_DISPLAY_GRADIENT_ON_GRID,
  RESET_HEATMAP_STATE,
  HeatMapDateRangeState,
  SetHeatMapMetricAction,
  SetHeatMapDateRangeAction,
  SetHeatMapHighColorAction,
  SetHeatMapLowColorAction,
  SetDisplayGradientOnGridAction,
  ResetHeatMapStateAction,
} from "./HeatMapTypes";

export const setHeatMapMetric = (
  metric: string,
): SetHeatMapMetricAction => ({
  type: SET_HEATMAP_METRIC,
  payload: { metric },
});

export const setHeatMapDateRange = (
  dateRange: HeatMapDateRangeState,
): SetHeatMapDateRangeAction => ({
  type: SET_HEATMAP_DATE_RANGE,
  payload: dateRange,
});

export const setHeatMapHighColor = (
  color: string,
): SetHeatMapHighColorAction => ({
  type: SET_HEATMAP_HIGH_COLOR,
  payload: { color },
});

export const setHeatMapLowColor = (
  color: string,
): SetHeatMapLowColorAction => ({
  type: SET_HEATMAP_LOW_COLOR,
  payload: { color },
});

export const setDisplayGradientOnGrid = (
  enabled: boolean,
): SetDisplayGradientOnGridAction => ({
  type: SET_DISPLAY_GRADIENT_ON_GRID,
  payload: { enabled },
});

/**
 * Reset the heat map slice.
 *
 * - Called with no args (e.g. modal close): the reducer preserves
 *   metric / colors / date range / gradient-on-grid flag when the flag
 *   is currently on, so the grid keeps painting after dismissal.
 * - Called with `false` (e.g. category change): forces a full reset,
 *   including the gradient flag, so a new category starts clean.
 *
 * The payload must be attached whenever the argument is **provided**
 * — including `false`. Using `displayGradientOnGrid && { payload }`
 * would short-circuit on `false` and silently drop the payload, making
 * `resetHeatMapState(false)` indistinguishable from `resetHeatMapState()`
 * (which was the original bug).
 */
export const resetHeatMapState = (
  displayGradientOnGrid?: boolean,
): ResetHeatMapStateAction => ({
  type: RESET_HEATMAP_STATE,
  ...(displayGradientOnGrid !== undefined && {
    payload: { displayGradientOnGrid },
  }),
});
